import { Banner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

const BecomeBanner = () => {
  const {
    access: { id: accessId, fullName },
  } = useCurrentSession()
  const { navigation } = useNavigation()

  const endBecome = async () => {
    // NOTE: this replaces the `rpc` method from the User model.
    //       We decided to do a simple fetch instead of adding the method as a mutation
    //       in GraphQL because we don't have access to neither session neither warden
    //       methods in the GraphQL context.
    const response = await fetch(buildUrl(`/accesses/${accessId}/end_become`), {
      method: 'POST',
      credentials: 'include',
    })

    if (response.ok) {
      window.location.href = navigation.dashboard.fullPath()
    }
  }

  return (
    <Banner
      label={i18n.t('employees.become.banner.text', { name: fullName })}
      link={{
        label: i18n.t('employees.become.banner.sign_out'),
        onClick: endBecome,
      }}
    />
  )
}

export default observer(BecomeBanner)
